import { useEffect } from "react";
import { useHeaderTitle } from "../../../../hooks/useHeaderTitle";
import PrevButton from "../../../atoms/buttons/PrevButton";
import Text from "../../content/Text";

const SubHeader = ({ title }) => {
  const { setTitle } = useHeaderTitle();

  useEffect(() => {
    setTitle(title);
  }, []);

  return (
    <div className="hidden md:flex items-center gap-6 my-6">
      <PrevButton />
      <Text variant="bold" className="text-sm">
        {title}
      </Text>
    </div>
  );
};

export default SubHeader;
